import React from 'react';
import cn from 'classnames';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import Submit from 'shared/components/Form/Submit';
import { ROLE } from 'shared/constants';
import EduTrainingsLogo from 'userportal/assets/edu_trainings.png';
import CzechitasLogo from 'userportal/assets/czechitas.png';
import EngetoLogo from 'userportal/assets/engeto.png';
import ReactGirlsLogo from 'userportal/assets/react_girls.svg';
import GopasLogo from 'userportal/assets/gopas.svg';
import styles from './EduPromos.module.scss';

const EduPromos = ({ job }) => {
  const location = useLocation();
  const qs = queryString.parse(location.search);

  const isFrontendDevJob = (job.roles || []).some(role => role.id === ROLE.FRONTEND_DEVELOPER);

  return (
    <>
      {/* EDU Trainings prototype */}
      {'edu' in qs && (
        <div className={styles.promo}>
          <h2>
            <i className="la la-school" />
            Chybí Vám potřebné dovednosti?
          </h2>
          <p>
            <img src={EduTrainingsLogo} className={styles.eduTrainingsLogo} alt="" />
            Doplňte si kvalifikaci prostřednictvím profesionálně vedených kurzů, které Vám
            nabízíme ve spolupráci se společností <strong>EDU Trainings</strong> a ucházejte se třeba i o tuto pracovní pozici.
          </p>
          <ul className={styles.demoCourses}>
            <li>
              <div className={styles.description}>
                <h4><i className="lab la-python" /> <strong>Python programming</strong> <small>(délka kurzu: 4 dny)</small></h4>
                <p>
                  This course will introduce You into the world of Python programming and it will make you familiar with the entire Python ecosystem.
                </p>
              </div>
              <div className={styles.cta}>
                <Submit title="detail kurzu" />
              </div>
            </li>
            <li>
              <div className={styles.description}>
                <h4><i className="lab la-react" /> <strong>React</strong> <small>(délka kurzu: 2 dny)</small></h4>
                <p>
                  Starting with React might not be easy at first. With the right online course you’ll get the needed guidance to make progress quickly. Being able to follow practical examples makes it easy to understand this new technology and helps to put your new knowledge into practice.
                </p>
              </div>
              <div className={styles.cta}>
                <Submit title="detail kurzu" />
              </div>
            </li>
          </ul>
        </div>
      )}
      {/* /EDU Trainings prototype */}

      {/* ENGETO Trainings prototype */}
      {'engeto' in qs && isFrontendDevJob && (
        <div className={styles.promo}>
          <h2>
            <i className="la la-school" />
            Chybí Vám potřebné dovednosti?
          </h2>
          <p>
            <a href="https://engeto.cz" target="_blank" rel="noopener noreferrer"><img src={EngetoLogo} className={styles.engetoLogo} alt="" /></a>
            Doplňte si kvalifikaci prostřednictvím profesionálně vedených kurzů, které Vám
            nabízíme ve spolupráci se společností <a href="https://engeto.cz" target="_blank" rel="noopener noreferrer"><strong>ENGETO</strong></a> a ucházejte se třeba i o tuto pracovní pozici.
          </p>
          <ul className={styles.demoCourses}>
            <li>
              <div className={styles.description}>
                <h4>
                  <i className="lab la-python" />
                  <a href="https://engeto.cz/webova-akademie/" target="_blank" rel="noopener noreferrer">
                    <strong>Front-end Developer Akademie</strong>
                  </a>
                  <small>(12 týdenní večerní program)</small>
                </h4>
                <p>
                JavaScript, HMTL a CSS. To je povinná výbava každého, kdo chce programovat weby. A že to je v dnešní online době dovednost, se kterou se rozhodně neztratíš. Přihlas se na Akademii, nauč se všechno potřebné a získej práci jako junior Front-end Developer.
                </p>
              </div>
              <div className={styles.cta}>
                <a href="https://engeto.cz/webova-akademie/" target="_blank" rel="noopener noreferrer">
                  <Submit title="detail kurzu" />
                </a>
              </div>
            </li>
          </ul>
        </div>
      )}
      {/* /ENGETO Trainings prototype */}

      {/* React girls Trainings prototype */}
      {'girls' in qs && (
        <div className={styles.promo}>
          <h2>
            <i className="la la-school" />
            Chybí Vám potřebné dovednosti?
          </h2>
          <p>
            <img src={ReactGirlsLogo} className={styles.reactGirlsLogo} alt="" />
            Doplňte si kvalifikaci prostřednictvím profesionálně vedených kurzů, které Vám
            nabízíme ve spolupráci s <strong>Akademií ReactGirls</strong> a ucházejte se třeba i o tuto pracovní pozici.
          </p>
          <ul className={styles.demoCourses}>
            <li>
              <div className={styles.description}>
                <h4><i className="lab la-html5" /> <strong>HTML</strong></h4>
                <p>
                  Zúčastníte se celkem 6 lekcí zaměřených na budování vašich technických dovedností v HTML a CSS. Po absolvování akademie budete mít možnost vyzkoušet si mock interview se zkušeným HR.
                </p>
              </div>
              <div className={styles.cta}>
                <Submit title="detail kurzu" />
              </div>
            </li>
            <li>
              <div className={styles.description}>
                <h4><i className="lab la-js-square" /> <strong>Javascript</strong></h4>
                <p>
                  Seznámení se s programováním v jazyce JavaScript a React, vhodné pro začátečníky. Budete součástí závěrečného workshopu, kde si získané znalosti ověříte v praxi. Získáte od nás i certifikát o absolvování akademie.
                </p>
              </div>
              <div className={styles.cta}>
                <Submit title="detail kurzu" />
              </div>
            </li>
          </ul>
        </div>
      )}
      {/* /React girls Trainings prototype */}

      {/* Czechitas prototype */}
      {'czechitas' in qs && (
        <div className={styles.promo}>
          <h2>
            <i className="la la-school" />
            Chybí Vám potřebné dovednosti?
          </h2>
          <div className={styles.czechitasDesc}>
            <img src={CzechitasLogo} className={styles.czechitasLogo} alt="" />
            <p>
              Doplňte si kvalifikaci prostřednictvím profesionálně vedených kurzů, které Vám
              nabízíme ve spolupráci s organizací <strong>Czechitas</strong> a ucházejte se třeba i o tuto pracovní pozici.
            </p>
          </div>
          <ul className={cn(styles.demoCourses, styles.czechitas)}>
            <li>
              <div className={styles.description}>
                <h4><i className="lab la-js-square" /> <strong>Úvod do programování 1: JavaScript</strong> <small>(1-2 dny)</small></h4>
                <p>
                Láká tě programování, ale nevíš, jak začít? Provedeme tě prvními krůčky a ukážeme, že je to zábava ne jen nudný shluk závorek, písmen a číslic.
                </p>
                <p>
                Podíváme se na proměnné, cykly a podmínky a procvičíme si je v online editoru. Naučíš se principy programování, které pak můžeš využít v jakémkoliv jazyce.
                </p>
              </div>
              <div className={styles.cta}>
                <Submit title="detail kurzu" />
              </div>
            </li>
            <li>
              <div className={styles.description}>
                <h4><i className="lab la-python" /> <strong>Úvod do programování 1: Python</strong> <small>(1-2 dny)</small></h4>
                <p>
                Láká tě programování, ale nevíš, jak začít? Provedeme tě prvními krůčky a ukážeme, že je to zábava ne jen nudný shluk závorek, písmen a číslic.
                </p>
                <p>
                  Co se naučíš: Kde všude se můžeme s programováním potkat, proměnné a datové typy, první krůčky s  Pythonem, základy algoritmizace hravě, cykly, podmínky.
                </p>
              </div>
              <div className={styles.cta}>
                <Submit title="detail kurzu" />
              </div>
            </li>
          </ul>
        </div>
      )}
      {/* /Czechitas prototype */}

      {/* GOPAS prototype */}
      {'gopas' in qs && (
        <div className={styles.promo}>
          <h2>
            <i className="la la-school" />
            Chybí Vám potřebné dovednosti?
          </h2>
          <div className={styles.czechitasDesc}>
            <img src={GopasLogo} className={styles.gopasLogo} alt="" />
            <p>
              Doplňte si kvalifikaci prostřednictvím profesionálně vedených kurzů, které Vám
              nabízíme ve spolupráci s <strong>Počítačovou školou GOPAS</strong> a ucházejte se třeba i o tuto pracovní pozici.
            </p>
          </div>
          <ul className={cn(styles.demoCourses, styles.gopas)}>
            <li>
              <div className={styles.description}>
                <h4><i className="lab la-java" /> <strong>Vývoj databázových aplikací v Javě</strong> <small>(5 dní)</small></h4>
                <p>
                  Kurz se zaměřuje na přístup Java aplikací do databáze. V rámci kurzu se podíváme nejprve na low-level přístup práce s databází pomocí JDBC & JdbcTemplate, což je vhodné zejména pro batchové zpracování, dále co by měli programátoři vědět o SQL tak, aby nenadávali na to, že je databáze pomalá (obyčejně není, jenom se špatně používá), ale hlavně se zaměříme na efektivní používání databáze pomocí JPA a Spring Data JPA.
                </p>
              </div>
              <div className={styles.cta}>
                <Submit title="detail kurzu" />
              </div>
            </li>
            <li>
              <div className={styles.description}>
                <h4><i className="las la-project-diagram" /> <strong>Praktické řízení projektů</strong> <small>(2 dny)</small></h4>
                <p>
                  Kurz poskytuje praktický úvod do řízení projektů, seznámení s jednotlivými fázemi životního cyklu projektu, jeho jednotlivými procesy a vybranými dovednostmi vedoucích projektů. Po absolvování kurzu bude účastník schopen samostatně naplánovat, řídit a ukončit malý nebo středně velký projekt.
                </p>
              </div>
              <div className={styles.cta}>
                <Submit title="detail kurzu" />
              </div>
            </li>
          </ul>
        </div>
      )}
      {/* /GOPAS prototype */}
    </>
  );
};

export default EduPromos;
